import Bestellung from "@/entities/common/bestellung"
import BPNachbestellenBeginnenRequest from "@/entities/common/pending/bp_nachbestellen_beginnen_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import SocketMessageType from "@/util/socket_message_types"
import Formatter from "../formatter"
import BaseLogic from "../base_logic"
import ServiceAnfordernRequest from "@/entities/common/request/service_anfordern_request"
import NachbestellungPending from "@/entities/common/nachbestellung_pending"
import ServiceanforderungEntity from "@/entities/common/serviceanforderung"

export default class DetailsSofortLogic extends BaseLogic {
  bestellung: Bestellung = null
  service: Serviceanforderung = null
  serviceDialogVisible: boolean = false

  serviceanforderungErstellen() {
    this.service = new Serviceanforderung()
    this.serviceDialogVisible = true
  }

  serviceAbsenden() {
    var request = new ServiceAnfordernRequest()
    request.bestellungId = this.bestellung.id
    request.kommentare = this.service.kommentare
    request.rechnungAnfordern = this.service.rechnungAnfordern

    Poster.postUser<RemoteResult<ServiceanforderungEntity>>(
      RestPaths.bestellungKundeServiceAnfordern,
      request
    ).then((response) => {
      if (response.data.success) {
        this.serviceDialogVisible = false
        this.mainLogic.bestellung.sofort.serviceanforderungen.push(
          response.data.payload
        )
      }
    })
  }

  berechneGesamtpreis(): number {
    var artikellistepreis = Formatter.berechnePreisListe(
      this.bestellung.artikelliste
    )
    return artikellistepreis
  }

  berechneGesamtpreisTrinkgeld(): number {
    var gesamtpreis = this.berechneGesamtpreis()

    var trinkgeld = this.bestellung.trinkgeld
    if (trinkgeld != null) {
      gesamtpreis = gesamtpreis + trinkgeld
    }
    return gesamtpreis
  }

  init() {
    this.bestellung = this.mainLogic.bestellung
    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
    })

    store.watch(
      (state) => state.incomingMessage,
      (newValue) => {
        if (!newValue) return
        if (!(newValue.type == SocketMessageType.ANFORDERUNG_STATUS_UPDATE))
          return
        var payload = JSON.parse(newValue.payload)
        this.bestellung.sofort.serviceanforderungen.forEach((s) => {
          if (s.id == payload.id) {
            s.status = payload.status
          }
        })
      }
    )
  }

  serviceAnfordern() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.SERVICE_ANFORDERN })
  }

  nachbestellen() {
    var request = new BPNachbestellenBeginnenRequest()
    request.bestellungId = this.bestellung.id

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingNachbestellenBeginnen,
      request
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellung.nachbestellungPending =
          new NachbestellungPending()
        this.mainLogic.bestellung.nachbestellungPending.id =
          response.data.payload
        router.push({ name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.PRODUKTE })
      }
    })
  }

  bezahlen() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.BEZAHLEN })
  }
}

class Serviceanforderung {
  rechnungAnfordern: boolean = false
  kommentare: string
}
